'use strict'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography
} from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning'

export default function StalenessModal ({ open, onClose, freshness, onSyncNow, onProceedStale, syncing = false }) {
  if (!freshness) return null

  const routingAge = freshness.routingSyncAgeHours == null
    ? 'missing'
    : `${freshness.routingSyncAgeHours}h ago`
  const workTicketAge = freshness.workTicketSyncAgeHours == null
    ? 'missing'
    : `${freshness.workTicketSyncAgeHours}h ago`
  const reasons = Array.isArray(freshness.staleReasons) && freshness.staleReasons.length
    ? freshness.staleReasons
    : ['unknown']

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle style={{ borderBottom: '1px solid var(--df-line, #e0d8c2)', paddingBottom: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <WarningIcon style={{ color: '#a4502f', fontSize: 20 }} />
          <span style={{ fontSize: 16, fontWeight: 700, color: 'var(--df-ink, #1c2419)' }}>Stale Data Detected</span>
        </div>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 16 }}>
        {/* Warning banner */}
        <div style={{
          padding: '12px 14px', borderRadius: 8, marginBottom: syncing ? 8 : 16,
          background: '#fbe8d6', border: '1px solid #e8c4a8', color: '#a4502f',
          display: 'flex', alignItems: 'flex-start', gap: 8
        }}>
          <WarningIcon style={{ fontSize: 18, marginTop: 1, flexShrink: 0 }} />
          <Typography variant="body2" style={{ color: '#a4502f', fontWeight: 500 }}>
            The underlying Aspire data is stale. Creating a scenario from outdated data may produce inaccurate results.
          </Typography>
        </div>
        {syncing && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16,
            padding: '8px 14px', borderRadius: 6,
            background: 'var(--df-surface-2, #f4f2ec)', border: '1px solid var(--df-line, #e0d8c2)'
          }}>
            <CircularProgress size={14} style={{ color: 'var(--df-primary, #3a6634)', flexShrink: 0 }} />
            <Typography variant="body2" style={{ color: 'var(--df-ink-2, #4a5548)', fontSize: 12 }}>
              Syncing… this can take several minutes.
            </Typography>
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {/* Routing sync */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ minWidth: 140, fontSize: 12, fontWeight: 600, color: 'var(--df-ink-3)' }}>Routing sync:</span>
            <span className="rw-pill pill-freq">{routingAge}</span>
          </div>

          {/* Work ticket sync */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ minWidth: 140, fontSize: 12, fontWeight: 600, color: 'var(--df-ink-3)' }}>Work ticket sync:</span>
            <span className="rw-pill pill-freq">{workTicketAge}</span>
          </div>

          {/* Threshold */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ minWidth: 140, fontSize: 12, fontWeight: 600, color: 'var(--df-ink-3)' }}>Threshold:</span>
            <span className="rw-pill pill-freq">{freshness.freshnessThresholdHours || 6}h</span>
          </div>

          {/* Reasons */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ minWidth: 140, fontSize: 12, fontWeight: 600, color: 'var(--df-ink-3)' }}>Reasons:</span>
            {reasons.map((r, i) => (
              <span key={i} className="rw-pill" style={{
                background: '#fbe8d6', color: '#a4502f', fontSize: 10.5
              }}>
                {r}
              </span>
            ))}
          </div>
        </div>
      </DialogContent>
      <DialogActions style={{ borderTop: '1px solid var(--df-line, #e0d8c2)', padding: '12px 24px' }}>
        <Button onClick={onClose} style={{ color: 'var(--df-ink-3)' }}>Cancel</Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={onSyncNow}
          disabled={syncing}
          style={{ fontWeight: 600, minWidth: 110 }}
          startIcon={syncing ? <CircularProgress size={14} style={{ color: 'inherit' }} /> : undefined}
        >
          {syncing ? 'Syncing…' : 'Sync Now'}
        </Button>
        <Button
          variant="contained"
          onClick={onProceedStale}
          disabled={syncing}
          style={{
            fontWeight: 600, background: syncing ? undefined : '#a4502f', color: '#fff',
            borderColor: '#a4502f'
          }}
        >
          Proceed with Stale Data
        </Button>
      </DialogActions>
    </Dialog>
  )
}
